// #126 — the web account-menu header's plan line for a free plan (Emily's copy, #126 note 4153963557):
// "{planName} · Free", using the server-authored name verbatim. If the name already contains the
// STANDALONE word "Free" (any case), the name alone. A partial match such as "Freestyle" is not the
// word "Free", so it still gets " · Free" — the line exists to carry the billing status.
const STANDALONE_FREE = /(^|[^\p{L}\p{N}])free($|[^\p{L}\p{N}])/iu;

export function freePlanLine(planName: string): string {
  return STANDALONE_FREE.test(planName) ? planName : `${planName} · Free`;
}
